import * as yup from "yup";

export const validations = yup.object({
  username: yup.string().required("Wajib diisi"),
  password: yup.string().required("Wajib diisi"),
  id_region: yup.string().required("Wajib diisi"),
});
